var _defs, _path, _path2, _path3, _path4, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgExtensivoR12324Logo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Grupo_3907",
    "data-name": "Grupo 3907",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 582.509,
    height: 136.813,
    viewBox: "0 0 582.509 136.813",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_1693",
    "data-name": "Ret\\xE2ngulo 1693",
    width: 582.509,
    height: 136.813,
    fill: "none"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1054",
    "data-name": "Caminho 1054",
    d: "M46.994,45.723V59.729H2.873V1.086H46.994V14.619H20.53v8.507H41.925V36.142H20.53v9.582Z",
    transform: "translate(-0.488 -0.184)",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1055",
    "data-name": "Caminho 1055",
    d: "M113.516,1.086,96.47,28.288l19.752,31.44H95.276L84.448,41.261,73.517,59.728H57.044L75.933,29.447,57.817,1.086h21l9.1,15.782L97.354,1.086Z",
    transform: "translate(-9.689 -0.184)",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1056",
    "data-name": "Caminho 1056",
    d: "M156.081,15.135V59.729H139.027V15.135H126.868V1.085H168.24V15.135Z",
    transform: "translate(-21.549 -0.184)",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1057",
    "data-name": "Caminho 1057",
    d: "M226.985,45.723V59.729H182.863V1.086h44.122V14.619H200.52v8.507h21.395V36.142H200.52v9.582Z",
    transform: "translate(-31.059 -0.184)",
    fill: "#fff"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_3906",
    "data-name": "Grupo 3906"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_3905",
    "data-name": "Grupo 3905",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1058",
    "data-name": "Caminho 1058",
    d: "M294.737,59.729H280.088l-16.061-25.91a98.614,98.614,0,0,1-6.237-12.112,40.811,40.811,0,0,1,1.419,9.623v28.4H244.6V1.086h17.013l13.663,21.478a83.1,83.1,0,0,1,6.185,11.258,85.255,85.255,0,0,1-1.375-15.38V1.086h14.649Z",
    transform: "translate(-41.546 -0.184)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1059",
    "data-name": "Caminho 1059",
    d: "M310.016,42.573l16.711-3.008q2.1,7.089,10.826,7.089,6.789,0,6.788-3.609a3.348,3.348,0,0,0-1.567-2.942,16.826,16.826,0,0,0-5.608-1.868q-15.425-2.956-19.806-7.725a16.051,16.051,0,0,1-4.38-11.218,17.552,17.552,0,0,1,6.3-13.793Q325.567,0,337.381,0,355.3,0,361.054,14.391L346.146,18.9q-2.32-5.886-9.408-5.887-5.886,0-5.887,3.653a2.884,2.884,0,0,0,1.333,2.534,16.258,16.258,0,0,0,5.155,1.717,108.781,108.781,0,0,1,14.953,3.939,16.117,16.117,0,0,1,7.387,5.86,16.39,16.39,0,0,1,2.962,9.781,17.325,17.325,0,0,1-7.217,14.423q-7.217,5.524-18.945,5.523-21.44,0-26.464-17.871",
    transform: "translate(-52.657 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_1690",
    "data-name": "Ret\\xE2ngulo 1690",
    width: 18.002,
    height: 58.643,
    transform: "translate(316.859 0.902)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1060",
    "data-name": "Caminho 1060",
    d: "M465.452,1.086l-18.2,58.643H428.911L409.883,1.086h18.97l9.28,31.963q.949,2.835,1.683,5.584L450.652,1.086Z",
    transform: "translate(-69.619 -0.184)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1061",
    "data-name": "Caminho 1061",
    d: "M506.226,60.446q-12.372,0-20.17-8.205t-7.8-21.953q0-13.147,7.455-21.716T506.4,0q12.244,0,19.955,8.077t7.712,21.566q0,13.961-7.777,22.382t-20.062,8.42m-.086-13.318a6.807,6.807,0,0,0,6.552-3.973q2-3.975,2-14.543,0-15.3-8.2-15.294-8.851,0-8.85,17.442,0,16.368,8.507,16.367",
    transform: "translate(-81.232)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1062",
    "data-name": "Caminho 1062",
    d: "M47.174,136.015l-.672,14.98H0v-14.04l10.389-7.29q2.284-1.564,8.531-6.728T27.071,115a10.113,10.113,0,0,0,1.9-5.813,6.54,6.54,0,0,0-1.659-4.671,5.694,5.694,0,0,0-4.352-1.767q-6.73,0-7.538,10.552L0,110.305Q1.7,99.529,8.428,94.274a25.078,25.078,0,0,1,15.9-5.253q9.927,0,16.209,5.32a17.65,17.65,0,0,1,6.283,14.176A20.416,20.416,0,0,1,43.4,119.739q-3.419,5.323-20.01,16.276Z",
    transform: "translate(0 -15.12)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1063",
    "data-name": "Caminho 1063",
    d: "M88.667,151.933a20.611,20.611,0,0,1-17.485-8.695q-6.439-8.7-6.439-22.873,0-14.529,6.595-22.938a21.279,21.279,0,0,1,17.641-8.406q11.581,0,17.752,8.966T112.9,120.9q0,14.219-6.641,22.626a21.3,21.3,0,0,1-17.594,8.406m.178-12.967q3.845,0,5.141-4.9a54.519,54.519,0,0,0,1.3-13.391q0-11.67-1.722-15.249t-4.673-3.577q-3.578,0-4.942,4.719a48.8,48.8,0,0,0-1.362,12.988q0,11.227,1.362,15.315t4.9,4.091",
    transform: "translate(-10.997 -15.12)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1064",
    "data-name": "Caminho 1064",
    d: "M176.554,136.015l-.672,14.98h-46.5v-14.04l10.389-7.29q2.286-1.564,8.533-6.728t8.15-7.939a10.118,10.118,0,0,0,1.9-5.813,6.54,6.54,0,0,0-1.659-4.671,5.7,5.7,0,0,0-4.352-1.767q-6.732,0-7.537,10.552l-15.427-2.994q1.7-10.776,8.429-16.031a25.07,25.07,0,0,1,15.9-5.253q9.927,0,16.209,5.32a17.65,17.65,0,0,1,6.283,14.176,20.416,20.416,0,0,1-3.421,11.223q-3.419,5.323-20.009,16.276Z",
    transform: "translate(-21.975 -15.12)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1065",
    "data-name": "Caminho 1065",
    d: "M192.131,132.348l15.918-1.967q1.565,8.362,8.943,8.363A8.264,8.264,0,0,0,222.447,137a5.783,5.783,0,0,0,2.1-4.694,5.564,5.564,0,0,0-1.14-3.465,6.722,6.722,0,0,0-2.437-2.1,11.646,11.646,0,0,0-4.471-.6h-7.423V113.389h6.26q5.008,0,6.439-1.789a5.872,5.872,0,0,0,1.431-3.71,5.189,5.189,0,0,0-1.789-4.025,6.746,6.746,0,0,0-4.694-1.61q-6.262,0-7.647,6.976l-14.756-2.325A21.686,21.686,0,0,1,202.84,93.67a25.792,25.792,0,0,1,15.4-4.65q10.017,0,16.1,4.694a15.026,15.026,0,0,1,6.081,12.52,13.411,13.411,0,0,1-2.572,8.184,12.468,12.468,0,0,1-6.55,4.694q11,3.355,11,14.355,0,8.764-6.686,13.616t-17.327,4.85q-21.373,0-26.157-19.585",
    transform: "translate(-32.634 -15.12)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_1691",
    "data-name": "Ret\\xE2ngulo 1691",
    width: 22.67,
    height: 14.04,
    transform: "translate(213.334 101.274)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1066",
    "data-name": "Caminho 1066",
    d: "M336.258,136.015l-.67,14.98h-46.5v-14.04l10.389-7.29q2.284-1.564,8.531-6.728t8.15-7.939a10.108,10.108,0,0,0,1.9-5.813,6.541,6.541,0,0,0-1.661-4.671,5.689,5.689,0,0,0-4.35-1.767q-6.732,0-7.539,10.552l-15.426-2.994q1.7-10.776,8.428-16.031a25.08,25.08,0,0,1,15.9-5.253q9.927,0,16.208,5.32a17.645,17.645,0,0,1,6.283,14.176,20.416,20.416,0,0,1-3.421,11.223q-3.419,5.323-20.009,16.276Z",
    transform: "translate(-49.101 -15.12)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1067",
    "data-name": "Caminho 1067",
    d: "M377.752,151.933a20.608,20.608,0,0,1-17.483-8.695q-6.439-8.7-6.439-22.873,0-14.529,6.595-22.938a21.277,21.277,0,0,1,17.641-8.406q11.578,0,17.75,8.966t6.171,22.915q0,14.219-6.64,22.626a21.307,21.307,0,0,1-17.6,8.406m.178-12.967q3.845,0,5.143-4.9a54.532,54.532,0,0,0,1.3-13.391q0-11.67-1.72-15.249t-4.673-3.577q-3.58,0-4.942,4.719a48.716,48.716,0,0,0-1.364,12.988q0,11.227,1.364,15.315t4.9,4.091",
    transform: "translate(-60.098 -15.12)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1068",
    "data-name": "Caminho 1068",
    d: "M465.638,136.015l-.67,14.98h-46.5v-14.04l10.389-7.29q2.284-1.564,8.531-6.728t8.15-7.939a10.108,10.108,0,0,0,1.9-5.813,6.541,6.541,0,0,0-1.661-4.671,5.689,5.689,0,0,0-4.35-1.767q-6.732,0-7.539,10.552l-15.426-2.994q1.7-10.776,8.428-16.031a25.08,25.08,0,0,1,15.9-5.253q9.927,0,16.208,5.32a17.645,17.645,0,0,1,6.283,14.176,20.416,20.416,0,0,1-3.421,11.223q-3.419,5.323-20.009,16.276Z",
    transform: "translate(-71.077 -15.12)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1069",
    "data-name": "Caminho 1069",
    d: "M532.481,137.58H523.9v13.415H507.083V137.58H482.132V124.3L505.116,89.02H523.9V124.3h8.585Zm-25.4-13.281V106.068L495.527,124.3Z",
    transform: "translate(-81.891 -15.12)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_1692",
    "data-name": "Ret\\xE2ngulo 1692",
    width: 118.93,
    height: 135.875,
    transform: "translate(463.579 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1070",
    "data-name": "Caminho 1070",
    d: "M606.09,95.084l18.316,35.695H605.027L589.274,98.272h-2.438v32.507H569.145V8.129H594.9q23.567.064,23.567,25.818V72.454q0,16.255-12.378,22.63M586.836,25.507V81.394H590.9a17.038,17.038,0,0,0,5.063-.5q4.813-1.936,4.814-7.814V33.884q0-8.377-7.69-8.377Z",
    transform: "translate(-96.67 -1.381)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1071",
    "data-name": "Caminho 1071",
    d: "M664.369,130.395V25.811L647.8,28.937V12.121L682.06,5.87V130.395Z",
    transform: "translate(-110.03 -0.997)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExtensivoR12324Logo);
export default __webpack_public_path__ + "static/media/extensivoR12324Logo.676e87d600643091a1be652b00002c6c.svg";
export { ForwardRef as ReactComponent };